
  import { Vue, Component } from 'vue-property-decorator';
  
  @Component
  export default class McCountStatusButtonTests extends Vue {
    
    created() {
    }

    mounted() {
    }
  }
